import React from 'react';
import Cta from './CTA/index'

function CTABlock({ headline, subheadline, buttonText, url, alt = false })
{
  return (
    <div className="pb-16">

      <div className={" text-center max-w-3xl mx-auto " + (alt && " bg-grey p-14")}>
        <h1 className="text-2xl md:text-4xl text-blue font-bold mb-4">{headline}</h1>
        <p>{subheadline}</p>
        <div className="mx-auto w-fit"><Cta title={buttonText} url={url} className="bg-green" /></div>
      </div>

    </div>
  );
}

export default CTABlock;